export const Imports = () => {
  return (
    <>
      <p>Self-serving imports are coming soon, for now drop us a line via Support and we'll help you import from your existing solution</p>
    </>
  )
}
